<!-- <ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{'active':selMenu=='users'}" (click)="selectMenu('users')">Users</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [ngClass]="{'active':selMenu == 'userType'}" (click)="selectMenu('userType')">Manage User Type</a>
  </li>
</ul> -->

<section class="mt-4" style="overflow-x: auto; height: 70vh;" *ngIf="selMenu=='users'">
  <table class="table table-hover white_box shadow">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Phone</th>
        <th scope="col">Role Assign</th>
        <th scope="col" class="text-center">User Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of totalMembers; let i = index;">
        <th scope="row" width="10%">{{i +1}}</th>
        <td width="10%">{{item?.phone | uppercase}}</td>
        <td>
          <div class="d-flex" style="max-width: 35rem;">
            <section class="row mt-2 mx-1" style="max-width: 35rem;">
              <ng-container *ngFor="let roles of (item?.memberUserTypes || [])">
                <span class="col sub-cate m-1"
                  *ngFor="let j of (roles?.userType?.roleUserTypes || [])">{{j?.role?.roleName
                  || ''}}</span>
              </ng-container>
            </section>
          </div>
        </td>
        <td width="30%">
          <div class="d-flex" style="max-width: 20rem;">
            <select class="form-control" (change)="onRoleChange($event.target.value)">
              <option [value]="null">Add Member Type</option>
              <option [value]="r.userTypeId" *ngFor="let r of (membersType || [])"> {{r?.userTypeName}}</option>
            </select>
            <span class="px-2 d-flex justify-content-center" style="align-items: center;">
              <button type="button" class="btn btn-primary d-flex"
                (click)="addUserTypeToUser(item.id,(item?.memberUserTypes || []))"><i class="fa fa-plus-circle "
                  title="Add Role" aria-hidden="true" style="font-size: 1.5rem;"></i></button>
            </span>
          </div>
          <section class="row mt-2 mx-1" style="max-width: 35rem;">
            <div class="my-2 p-0" *ngFor="let j of (item?.memberUserTypes || [])">
              <span class="sub-cate m-1">{{j?.userType?.userTypeName || ''}} <i class="fa fa-times" aria-hidden="true"
                  (click)="removeMemberUserTypes(j?.userUserTypeId)"></i></span>
            </div>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<section class="mt-4" style="overflow-x: auto; height: 70vh;" *ngIf="selMenu=='userType'">
  <section class="d-flex justify-content-between" style="gap: 5px;">
    <button type="submit" class="btn btn-dark mb-2" (click)="add(Add)"><i aria-hidden="true"
        class="fa fa-plus-circle"></i> Create</button>
  </section>
  <table class="table table-hover white_box shadow">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Role Type</th>
        <th scope="col">Role Assign</th>
        <th scope="col">Image</th>
        <th scope="col">Category</th>
        <th scope="col">Price <img loading="lazy" src="../../../assets/images/diamond.png" style="height: 20px; margin-right: 2px"
            class="rounded" /></th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of membersType; let i = index;">
        <th scope="row" width="10%">{{i +1}}</th>
        <td width="10%"> <span class="sub-cate" [ngClass]="{'reserve': item?.type == 'RESERVE'}">{{item?.userTypeName |
            uppercase}}</span></td>
        <td>
          <div class="d-flex" style="max-width: 35rem;">
            <select class="form-control" (change)="onRoleChange($event.target.value)">
              <option [value]="null">Add Role for Level</option>
              <option [value]="r.roleId" *ngFor="let r of (roleList || [])"> {{r?.roleName}}</option>
            </select>
            <span class="px-2 d-flex justify-content-center" style="align-items: center;">
              <button type="button" class="btn btn-primary d-flex"
                (click)="addRoleToUserType(item.userTypeId,(item?.roleUserTypes || []))"><i
                  class="fa fa-plus-circle mr-2" title="Add Role" aria-hidden="true" style="font-size: 1.5rem;"></i> Add
                Role</button>
            </span>
          </div>
          <section class="row mt-2 mx-1" style="max-width: 35rem;">
            <div class="col-12 my-2 p-0" *ngFor="let j of (item?.roleUserTypes || [])">
              <span class="sub-cate m-1">{{j?.role?.roleName || ''}} <i class="fa fa-times" aria-hidden="true"
                  (click)="deleteMemberTypeRelationship(j.roleUserTypeId)"></i></span>
            </div>
          </section>
        </td>
        <td> <img loading="lazy" *ngIf="item.image" style="height: 5rem;" [src]="imgUrl + item.image"></td>
        <td><span class="sub-cate">{{item?.type | uppercase}}</span></td>
        <td> <ng-container *ngIf="item?.price">
            {{item?.price }} <img loading="lazy" src="../../../assets/images/diamond.png" style="height: 20px; margin-right: 2px" class="rounded" />
          </ng-container>
        </td>
        <td class="text-right" width="15%">
          <section class="d-flex justify-content-center" style="gap: 5px;">
            <button class="btn btn-dark" (click)="add(Add,item)"><i class="fa fa-pencil" aria-hidden="true"></i>
              Edit</button>
            <button class="btn btn-danger" (click)="deleteItem(item?.userTypeId)"><i class="fa fa-trash"
                aria-hidden="true"></i> Delete</button>
          </section>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<ng-template #Add let-modal>
  <div class="modal-body">
    <div class="add_cattt d-flex justify-content-between">
      <h2>Add User Type</h2>
      <img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>

    <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100"
      style="height: 200px;object-fit: contain;" [src]="imageBase64" alt="" />
    <img loading="lazy" *ngIf="selectedCategory?.image" style="height: 200px;object-fit: contain;"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + selectedCategory?.image">

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()">
      <i class="fas fa-plus"></i> Upload Image
    </button>
    <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none"
      accept="image/*" />



    <form [formGroup]="form">
      <div class="referral-link">
        <section class="m-4">
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Enter User Type" maxlength="500"
              formControlName="name" />
          </div>
          <div class="form-group">
            <textarea type="text" class="form-control" placeholder="Enter Description" maxlength="500"
              formControlName="description"></textarea>
          </div>
          <div class="form-group">
            <input type="number" class="form-control" placeholder="Enter Price ( Diamond )" maxlength="500"
              formControlName="price" />
          </div>
          <div class="form-group">
            <select formControlName="type" class="form-control">
              <option value="DEFAULT">DEFAULT</option>
              <option value="RESERVE">RESERVE</option>
            </select>
          </div>
        </section>
        <div class="mt-4">
          <div class="cart_btn">
            <button class="com_btn add-review-btn px-2" (click)="addSubmit()">Save <i class="fa fa-save"
                aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>